import { getCurrentInstance } from "vue";
import { isNullish } from "@tinyurldev/tu-ui-vue";
import { logError } from "@Helpers/logger";

/**
 * @deprecated DO NOT USE IN NEW CODE. This composable is deprecated and will be removed.
 *
 * Use the appropriate Pinia stores instead:
 * - XAuthStore: authentication, user data, locale
 * - XDomainsStore: domains
 * - XTeamsStore: teams/organizations
 * - XOrdersStore: shopping cart orders
 *
 * If you need functionality that doesn't exist in a Pinia store, add it to the appropriate
 * store rather than using this legacy Vuex wrapper.
 *
 * @returns The legacy Vuex store instance.
 */
export default function useLegacyStore() {
  const $vm = getCurrentInstance();

  if (isNullish($vm.proxy)) {
    logError("[useLegacyStore]: no instance defined, call it inside a Vue component's setup context.");
  }

  return $vm?.proxy.$store;
}
